(function () {
  const gallery = document.querySelector('[data-co-gallery]');
  if (!gallery) return;

  const mainImg = gallery.querySelector('[data-co-main-img]');
  const thumbs = [...gallery.querySelectorAll('[data-co-thumb]')];
  const prevBtn = gallery.querySelector('[data-co-gallery-prev]');
  const nextBtn = gallery.querySelector('[data-co-gallery-next]');
  const thumbsTrack = gallery.querySelector('[data-co-thumbs-track]');
  let index = thumbs.findIndex((t) => t.classList.contains('is-active'));
  if (index < 0) index = 0;

  function setActive(i) {
    if (!thumbs.length) return;
    index = Math.max(0, Math.min(thumbs.length - 1, i));
    thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === index));
    const src = thumbs[index].dataset.full || thumbs[index].querySelector('img')?.src;
    if (mainImg && src) mainImg.src = src;
    if (prevBtn) prevBtn.disabled = index <= 0;
    if (nextBtn) nextBtn.disabled = index >= thumbs.length - 1;
    thumbs[index]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => setActive(i));
  });
  prevBtn?.addEventListener('click', () => setActive(index - 1));
  nextBtn?.addEventListener('click', () => setActive(index + 1));

  setActive(index);
})();
